import React from 'react';
import './CaOnlineCourses.css';

// SVG Icons matching screenshots
const BookIcon = () => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="#006100" className="Ca-course-card__icon">
    <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
  </svg>
);

const MicIcon = () => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="#006100" className="Ca-course-card__icon">
    <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
  </svg>
);

const BrainIcon = () => (
  <svg viewBox="0 0 576 512" width="40" height="40" fill="#006100" className="Ca-course-card__icon" xmlns="http://www.w3.org/2000/svg">
    <path d="M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z" />
  </svg>
);

const CaOnlineCourses = () => {
  const topCourses = [
    {
      id: 'noorani-qaida',
      icon: <BookIcon />,
      title: 'Noorani Qaida Course',
      description: 'Learn Noorani Qaida online from expert male and female tutors. Perfect for kids and adults who want to build a strong foundation in Quran recitation with proper pronunciation and Tajweed rules.'
    },
    {
      id: 'quran-tajweed',
      icon: <MicIcon />,
      title: 'Quran Tajweed Classes',
      description: 'Learn Quran with tajweed online from expert male and female tutors. Whether you are a kid or an adult. We teach everyone with proper guidance.'
    },
    {
      id: 'quran-reading',
      icon: <BrainIcon />,
      title: 'Quran Reading Classes Online',
      description: 'Get online Quran recitation classes with Juzz by Juzz to learn and improve your Quran reading capabilities, no matter if you are an adult or a kid.'
    }
  ];

  const bottomCourses = [
    {
      id: 'quran-memorization',
      icon: <MicIcon />,
      title: 'Quran Memorization Classes',
      description: 'Our Quran memorization course intends to help the students to memorize the Holy Quran with experienced and professional Huffaz.'
    },
    {
      id: 'quran-translation',
      icon: <BrainIcon />,
      title: 'Quran Translation Classes Online',
      description: 'This course is especially designed for students who want to learn to translate Quran so that they are able to understand the meaning of the verses of Quran.'
    }
  ];

  const handleCardClick = () => {
    const el = document.getElementById('detailed-courses');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="Ca-courses-section" id="courses">
      <div className="Ca-courses-section__container">
        {/* Header Badge */}
        <div className="Ca-courses-section__badge">
          <svg className="Ca-courses-section__badge-icon" viewBox="0 0 640 512" width="20" height="20" fill="#006100">
            <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"/>
          </svg>
          <span>Online Quran Courses</span>
        </div>

        {/* Main Section Title */}
        <h2 className="Ca-courses-section__title">
          Online Quran Classes for Every Level, From Beginners to Advanced
        </h2>

        {/* Subtitle Paragraph */}
        <p className="Ca-courses-section__description">
          Our online Quran courses are structured progressively, so students begin at the right level and advance through a proven curriculum. Every course is taught in private, one-on-one live sessions with a certified tutor. Here is what we teach:
        </p>

        {/* Top 3 Cards Row */}
        <div className="Ca-courses-grid Ca-courses-grid--top">
          {topCourses.map((course) => (
            <div key={course.id} className="Ca-course-card" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
              <div className="Ca-course-card__icon-wrapper">
                {course.icon}
              </div>
              <h3 className="Ca-course-card__title">{course.title}</h3>
              <p className="Ca-course-card__desc">{course.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom 2 Centered Cards Row */}
        <div className="Ca-courses-grid Ca-courses-grid--bottom">
          {bottomCourses.map((course) => (
            <div key={course.id} className="Ca-course-card" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
              <div className="Ca-course-card__icon-wrapper">
                {course.icon}
              </div>
              <h3 className="Ca-course-card__title">{course.title}</h3>
              <p className="Ca-course-card__desc">{course.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaOnlineCourses;
